import { z } from 'zod';
import { ScanEffortLevelSchema } from '../scan-effort/scan-effort.schema';

export const FULL_RESCAN_STEPS = [
  'CRAWL',
  'FEATURE_ANALYSIS',
  'SIGNAL_CHECKS',
  'CODE_GRAPHS',
  'DEEP_SCAN',
  'BLOCKED_SIGNALS',
] as const;

export const FullRescanStepNameSchema = z.enum(FULL_RESCAN_STEPS);

export type FullRescanStepName = z.infer<typeof FullRescanStepNameSchema>;

export const FullRescanStepStatusSchema = z.enum([
  'TRIGGERED',
  'SKIPPED',
  'FAILED',
]);

export type FullRescanStepStatus = z.infer<typeof FullRescanStepStatusSchema>;

export const FullRescanStepResultSchema = z.object({
  step: FullRescanStepNameSchema,
  status: FullRescanStepStatusSchema,
  detail: z.string().nullable(),
});

export type FullRescanStepResult = z.infer<typeof FullRescanStepResultSchema>;

export const FullRescanFindingSummarySchema = z.object({
  findingId: z.string(),
  title: z.string(),
  severity: z.string(),
  category: z.string().nullable(),
});

export type FullRescanFindingSummary = z.infer<
  typeof FullRescanFindingSummarySchema
>;

export const FullRescanDiffSchema = z.object({
  newCount: z.number().int().nonnegative(),
  reconfirmedCount: z.number().int().nonnegative(),
  notReproducedCount: z.number().int().nonnegative(),
  newFindings: z.array(FullRescanFindingSummarySchema),
  reconfirmedFindings: z.array(FullRescanFindingSummarySchema),
  notReproducedFindings: z.array(FullRescanFindingSummarySchema),
});

export type FullRescanDiff = z.infer<typeof FullRescanDiffSchema>;

export const FullRescanRunSchema = z.object({
  id: z.string(),
  applicationId: z.string(),
  effortLevel: ScanEffortLevelSchema,
  requestedByUserId: z.string().nullable(),
  startedAt: z.string(),
  activeUntil: z.string(),
  active: z.boolean(),
  steps: z.array(FullRescanStepResultSchema),
  diff: FullRescanDiffSchema,
});

export type FullRescanRun = z.infer<typeof FullRescanRunSchema>;

export const LatestFullRescanResponseSchema = z.object({
  enabled: z.boolean(),
  run: FullRescanRunSchema.nullable(),
});

export type LatestFullRescanResponse = z.infer<
  typeof LatestFullRescanResponseSchema
>;
